






















































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { RootStoreState } from '@/store';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import { State } from 'vuex-class';
import { SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { envCongif } from '@/shared/env.config';

const cssPrefix = 'download_signature';

@Component({
  components: {
    MswAppTitle,
    SwSelect,
    SwForm,
    SwFormRow,
    SwIcon,
  },
  directives: {
    tooltip,
  },
})

export default class DownloadSignature extends SwExtendedVue {
  cssPrefix = cssPrefix;
  menuOpened: boolean = false;
  @State((state: RootStoreState) => state.DownloadSignatureStoreModule.signatureIDs)
  signatureIDs: any = [];
  sigApplicableProdList: any = [];
  allApplicableProdList: any = [];
  selectedItemId: string = '';
  sessionid: any = '';
  username: any = '';
  sigIDList: any = [];
  userNote: any = '';
  mounted() {
    this.getSignatureIDs();
    this.sessionid = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    this.username = this.$store.getters.getUserId;
  }
  get getInfoTooltip(): TooltipDirValues {
    const content = String(this.$t('products.keySetInfo'));
    return {
      content,
      placement: 'right',
      compact: true,
    };
  }
  getSignatureIDs() {
    this.$store.dispatch('DownloadSignatureStoreModule/getSignatureFiles')
    .then((res: any) => {
      this.$store.commit('stopLoading');
      this.$store.commit('DownloadSignatureStoreModule/setSigApplicableProdDetails', res.content.sigApplicableProdDetails);
      this.sigIDList = res.content.sigIDList;
      const filteredSignData = res.content.sigIDList.map((id: any) => {
        const item = {
          id: id.sigID,
          label: id.sigID,
          value: id.displayText,
        };
        return item;
      });
      this.$store.commit('DownloadSignatureStoreModule/setSignatureIDs', filteredSignData);
      this.signatureIDs = this.$store.getters['DownloadSignatureStoreModule/getSignatureIDs'];
      this.allApplicableProdList = res.content.sigApplicableProdList;
      this.selectedItemId = this.signatureIDs[0].id;
      if (res.content.sigApplicableProdList !== undefined) {
        this.sigApplicableProdList = res.content.sigApplicableProdList.filter((n: any) => n.sigID === this.signatureIDs[0].id);
      }
    })
    .catch((err) => {
      console.warn(err);
    });
  }
  onClickMenuButton() {
    this.menuOpened = !this.menuOpened;
  }
  getApplicableProduct(signId: any) {
    if (this.allApplicableProdList !== undefined) {
      this.sigApplicableProdList = this.allApplicableProdList.filter((n: any) => n.sigID === signId);
    }
  }
  onSelectItem(itemId: string) {
    this.selectedItemId = itemId;
    this.menuOpened = false;
    this.userNote = this.sigIDList.filter((id:any) => id.sigID === this.selectedItemId);
    this.getApplicableProduct(itemId);
  }
  downloadSignFile() {
    const host = envCongif.api_url;
    const url = `${host}/downloads/download-signaturefile-sigID?username=${this.username}&sessionID=${this.sessionid}&sigID=${this.selectedItemId}`;
    window.location.replace(url);
  }
  downloadZipFormat() {
    const host = envCongif.api_url;
    const url = `${host}/downloads/download-signaturefile-sigID?username=${this.username}&sessionID=${this.sessionid}&sigID=${this.selectedItemId}&strReturnZip=YES`;
    window.location.replace(url);
  }
}
